<script>
import Style from "@/views/layouts/style";
import appConfig from "@/../app.config";
import { LineChart } from "chartist";
import Swal from "sweetalert2";
import Consolidado from "../../pages/forms/evaluacion-indicadores-consolidado.vue"
import Estructura from "../../pages/forms/evaluacion-indicadores-estructura.vue"
import Proceso from "../../pages/forms/evaluacion-indicadores-proceso.vue"
import Resultado from "../../pages/forms/evaluacion-indicadores-resultado.vue"
import evaluacionIndicadoresAPI from "../../../services/standards/evaluacionIndicadores/evaluacionIndicadoresAPI";

export default {
  page: {
    title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Style,
    Consolidado,
    Estructura,
    Proceso,
    Resultado,
  },

  data() {
    return {
      title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Indicadores de Estructura, Proceso y Resultado",
          active: true,
        },
      ],

      loading: true,
      selected: null,
      itemData: null,

      years: [],
      selectYear: null,
      totales: {
        cumplidos: {},
        evaluados: {},
        porcentaje: {},
        cumplimiento: {},
      },
      chartData: {
        labels: [
          "Indicador de estructura",
          "Indicador de proceso",
          "Indicador de resultado",
          "Total de cumplimiento",
        ],
        series: [[], [], [], []],
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      token: this.$store.state.auth.user.token || null,
      excel: null,
    }
  },

  methods: {

    goBack() {
      this.$router.go(-1);
    },

    rangeYear() {
      const max = 2040;
      const min = 2018;
      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years;
    },

    async print() {
      try {
        evaluacionIndicadoresAPI.getExcel(this.companyID, this.selectYear)
          .then((response) => {
            window.location.href = response
          });
      } catch (error) {
        console.log(error);
      }
    },

    getTotales() {
      evaluacionIndicadoresAPI
        .totales(this.companyID, this.selectYear)
        .then((response) => {
          if (response.message === "No existe ficha técnica del año seleccionado") {
            this.selectYear = null
            setTimeout(() => {
              Swal.fire({
                title: "¡error, No existe ficha técnica del año seleccionado!",
                icon: 'error',
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }, 1000);
          } else {
            this.totales = response.data;
            this.chartData.series[0].push(this.totales.porcentaje.estructura);
            this.chartData.series[0].push(this.totales.porcentaje.proceso);
            this.chartData.series[0].push(this.totales.porcentaje.resultado);
            this.chartData.series[0].push(this.totales.porcentaje.total);
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

  },

  mounted() {
    this.rangeYear()
  }

}

</script>

<template>

  <div class="row">
    <div class="col-md-9 text-center">
      <select required class="col-md-6 form-control" v-model="selectYear" @change="getTotales">
        <b-form-select-option v-for="item in years" :value="item">
          {{ item }}
        </b-form-select-option>
      </select>
    </div>

    <div v-if="selectYear != null" class="col-md-12">
      <form class="form-group mt-2">
        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
          <thead>
            <tr>
              <th class="text-center align-middle"></th>
              <th class="text-center align-middle">
                Indicador de estructura
              </th>
              <th class="text-center align-middle">
                Indicador de proceso
              </th>
              <th class="text-center align-middle">
                Indicador de resultado
              </th>
              <th class="text-center align-middle">
                Total cumplimiento
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr>
              <td class="text-center align-middle">
                Total de items cumplidos
              </td>
              <td class="text-center align-middle">
                {{ this.totales.cumplidos.estructura }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.cumplidos.proceso }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.cumplidos.resultado }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.cumplidos.total }}
              </td>
            </tr>
            <tr>
              <td class="text-center align-middle">
                Total de items evaluados
              </td>
              <td class="text-center align-middle">
                {{ this.totales.evaluados.estructura }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.evaluados.proceso }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.evaluados.resultado }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.evaluados.total }}
              </td>
            </tr>
            <tr>
              <td class="text-center align-middle">
                Porcentaje de cumplimiento
              </td>
              <td class="text-center align-middle">
                {{ this.totales.porcentaje.estructura }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.porcentaje.proceso }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.porcentaje.resultado }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.porcentaje.total }}
              </td>
            </tr>
            <tr>
              <td class="text-center align-middle">Cumplimiento</td>
              <td class="text-center align-middle">
                {{ this.totales.cumplimiento.estructura }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.cumplimiento.proceso }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.cumplimiento.resultado }}
              </td>
              <td class="text-center align-middle">
                {{ this.totales.cumplimiento.cumple }}
              </td>
            </tr>
          </tbody>
        </table>
      </form>

      <div class="col-md-12 col-sm-12 text-right mb-3 d-flex justify-content-end align-items-center">
        <button @click="print" type="button" class="btn btn-primary" id="tooltip">
          <span class="btn-label">
            <i class="bx bx-download"></i></span>
          Descargar tabla a excel
        </button>

        <b-tooltip target="tooltip" placement="left">
          Descargar
        </b-tooltip>
      </div>

      <div class="card">
        <div class="card-body" dir="ltr">
          <h4 class="header-title">
            Representación grafica del indicador
          </h4>
          <ul>
            <li style="color: #00707f">Porcentaje de cumplimiento</li>
          </ul>
          <p class="sub-header"></p>

          <Chartist ratio="ct-chart" :data="chartData" type="Line"></Chartist>
        </div>
      </div>
    </div>
  </div>
</template>
